module.exports = __webpack_public_path__ + "163356e90c2149c4caad21ab7fd1717c.svg";